import { RequestStoreGetters } from "@/constants/store/request/requestStoreConstants";
import { Request, RequestFileMetadata } from "@/dataModel";
import { RequestState } from "@/typings/store/states/RequestStoreState";

export default {
  [RequestStoreGetters.GET_SELECTED_REQUEST]: (state: RequestState): Request | null => state.request,
  [RequestStoreGetters.GET_REQUEST_FILE_METADATA]: (state: RequestState): RequestFileMetadata | null =>
    state.requestFileMetadata,
};
